import * as types from "./types";
import axios from "../utils/api";
import moment from "moment";
const MOMENT_FORMAT = "YYYY-MM-DD";
const { REACT_APP_API_URL } = process.env;
// const REACT_APP_API_URL = "https://api.elutag.com"


export const registerDriverProfile = (dispatch, payload) => {
  dispatch({ type: types.DRIVER_PROFILE, payload: payload });
  axios
    .post(REACT_APP_API_URL + "/onboard_driver", payload)
    .then(function ({ data }) {
      dispatch({ type: types.DRIVER_PROFILE_CREATED, payload: data.response });
    })
    .catch(function (response) {
      if ([401, 400].includes(response.status)) {
        dispatch({
          type: types.DRIVER_PROFILE_CREATION_FAILED,
          payload: response.data.message,
        });
      }
    });
};

export const updateDriverProfile = (dispatch, id, payload, callback) => {
  console.log("TESTING DATA ON SUBMIT UPDATE :", { id, payload, callback })
  axios
    .put(REACT_APP_API_URL + "/drivers/" + id, payload)
    .then(function ({ data }) {
      dispatch({ type: types.DRIVER_PROFILE_UPDATED, payload: data.response });
      callback();
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveTitle = (dispatch) => {
  axios
    .post(REACT_APP_API_URL + "/retrieve_ref_table", {
      table_name: "title_ref",
    })
    .then(function ({ data }) {
      dispatch({ type: types.GET_TITLE, payload: data.response.result });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveGender = (dispatch) => {
  axios
    .post(REACT_APP_API_URL + "/retrieve_ref_table", {
      table_name: "sex_ref",
    })
    .then(function ({ data }) {
      dispatch({ type: types.GET_GENDER, payload: data.response.result });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const retrieveAddressType = (dispatch) => {
  axios
    .post(REACT_APP_API_URL + "/retrieve_ref_table", {
      table_name: "address_type_ref",
    })
    .then(function ({ data }) {
      dispatch({ type: types.GET_ADDRESS_TYPE, payload: data.response.result });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveCity = (dispatch) => {
  axios
    .post(REACT_APP_API_URL + "/retrieve_ref_table", {
      table_name: "city",
    })
    .then(function ({ data }) {
      dispatch({ type: types.GET_CITY, payload: data.response.result });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveCountry = (dispatch) => {
  axios
    .post(REACT_APP_API_URL + "/retrieve_ref_table", {
      table_name: "country",
    })
    .then(function ({ data }) {
      dispatch({ type: types.GET_COUNTRY, payload: data.response.result });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveState = (dispatch) => {
  axios
    .post(REACT_APP_API_URL + "/retrieve_ref_table", {
      table_name: "state",
    })
    .then(function ({ data }) {
      dispatch({ type: types.GET_STATE, payload: data.response.result });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveStateByCountryId = (dispatch, id) => {
  axios
    .get(REACT_APP_API_URL + "/states_by_country_id/" + id)
    .then((res) => {
      dispatch({ type: types.GET_STATE, payload: res.data.response.result });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const retrieveCitiesByCountryId = (dispatch, id) => {
  axios
    .get(REACT_APP_API_URL + "/cities_by_country_id/" + id)
    .then((res) => {
      dispatch({ type: types.GET_CITY, payload: res.data.response.result });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const retrieveChargingSites = (dispatch) => {
  axios
    .get(REACT_APP_API_URL + "/ev_charging_site")
    .then(function ({ data }) {
      dispatch({
        type: types.GET_CHARGING_SITES,
        payload: data.response.evChargingSites,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveDriverProfile = (dispatch, id) => {
  axios
    .get(REACT_APP_API_URL + "/drivers/" + id)
    .then(function ({ data }) {
      dispatch({
        type: types.GET_DRIVER_PROFILE,
        payload: data.response.driver,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveVehicleBrands = (dispatch) => {
  axios
    .get(REACT_APP_API_URL + "/vehicle_brand")
    .then(function ({ data }) {
      dispatch({
        type: types.GET_VEHICLE_BRANDS,
        payload: data.response.result,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveVehicleModels = (dispatch, vehicle_brand_id) => {
  axios
    .get(REACT_APP_API_URL + `/vehicle_model/${vehicle_brand_id}`)
    .then(function ({ data }) {
      dispatch({
        type: types.GET_VEHICLE_MODELS,
        payload: data.response.result,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const retrieveVehicleChargerTypes = (dispatch, id) => {
  axios
    .get(REACT_APP_API_URL + `/vehicle_charger_type/${id}`)
    .then(function ({ data }) {
      dispatch({
        type: types.GET_VEHICLE_CHARGER_TYPES,
        payload: data.response.result,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const createVehicle = (dispatch, driver_id, payload, callBack) => {
  axios
    .post(REACT_APP_API_URL + `/drivers/${driver_id}/vehicle`, payload)
    .then(function ({ data }) {
      callBack();
      dispatch({
        type: types.CREATE_DRIVER_VEHICLE,
        payload: data.response.driverVehicles,
      });
      retrieveDriverProfile(dispatch, driver_id);
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const deleteDriverVehicle = (dispatch, driver_id, driver_vehicle_id) => {
  axios

    .delete(
      REACT_APP_API_URL + `/driver/${driver_id}/vehicle/${driver_vehicle_id}`
    )
    .then(function ({ data }) {
      dispatch({
        type: types.DELETE_DRIVER_VEHICLE,
        payload: data.response.driverVehicles,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const updateDriverVehicle = (
  dispatch,
  driver_id,
  driver_vehicle_id,
  payload,
  callBack
) => {
  axios
    .put(
      REACT_APP_API_URL + `/drivers/${driver_id}/vehicle/${driver_vehicle_id}`,
      payload
    )
    .then(function ({ data }) {
      callBack();
      dispatch({
        type: types.UPDATE_DRIVER_VEHICLE,
        payload: {
          driver_vehicle_id,
          vehicle: payload,
        },
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getNotification = (dispatch, driver_id) => {
  axios
    .get(REACT_APP_API_URL + `/notification/driver/${driver_id}`)
    .then(function ({ data }) {
      dispatch({
        type: types.GET_READ_NOTIFICATION,
        payload: data.response.notifications,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const markNotificationAsRead = (dispatch, notificationId) => {
  axios
    .put(
      REACT_APP_API_URL +
      `/notification/mark_notification_as_read/${notificationId}/`,
      {}
    )
    .then(function ({ data }) {
      console.log(data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const authenticateDriver = (dispatch, payload) => {
  dispatch({ type: types.DRIVER_AUTHENTICATION_IN_PROCESS });
  axios
    .post(REACT_APP_API_URL + `/authenticate_driver`, payload)
    .then((res) => {
      dispatch({
        type: types.DRIVER_AUTHENTICATION_SUCCESS,
        data: res.data.response,
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: types.DRIVER_AUTHENTICATION_FAILED });
    });
};
export const deleteAccount = (payload,callback) => {
  axios
    .post(REACT_APP_API_URL + `/delete_driver`, payload)
    .then((res) => {
      let a = res.data;
      callback(a);
    })
    .catch((err) => {
      console.log(err);
      callback(err)
    });
};
export const forgotPassword = (dispatch, payload) => {
  axios
    .post(REACT_APP_API_URL + `/forgot_password`, payload)
    .then(({ data }) => {
      dispatch({
        type: types.PASSWORD_RESET_SUCCESS,
        data: data.message,
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: types.PASSWORD_RESET_FAILED });
    });
};

export const stationManagerNumber = (dispatch, driver_id) => {
  axios
    .get(REACT_APP_API_URL + `/station_manager_number/driver/${driver_id}`)
    .then((res) => {
      dispatch({
        type: types.GET_STATION_MANAGER_NUMBER,
        payload: res.data.response.stationManager,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetchBookings = (dispatch, start_date, end_date, driver_id) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  dispatch({
    type: types.GET_BOOKINGS,
    payload: {
      bookings: [],
      parkingSlotsPerDay: [],
    },
  });
  axios
    .post(REACT_APP_API_URL + `/bookings_new/driver/${driver_id}`, {
      start_date,
      end_date,
      ev_charging_site_id: localStorage.getItem("ev_charging_site_id"),
    })
    .then((res) => {
      dispatch({
        type: types.GET_BOOKINGS,
        payload: res.data.response,
        // payload: res.data.response.calendarArray,
      });
    });
};

export const getBookingAddress = (dispatch, id) => {
  axios
    .get(`${REACT_APP_API_URL}/booking/next/${id}`)
    .then((res) => {
      dispatch({
        type: types.GET_BOOKING_ADDRESS,
        payload: res.data.response.bookings,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getChargeBoxCharging = (dispatch, id,setNowCharging,setDisableButton) => {
  axios
    .get(`${REACT_APP_API_URL}/is_charge_box_charging/${id}`)
    .then((res) => {
      dispatch({
        type: types.GET_CHARGE_BOX_CHARGING,
        payload: res.data.response.is_charging
      });
    
        setNowCharging(res.data.response.is_charging)
        setDisableButton(false)

      
      // alert("hmm")
    })
    .catch((err) => {
      console.log(err);
    });
}

export const clearBookingDetails = (dispatch) => {
  dispatch({
    type: types.GET_BOOKING_DETAILS,
    payload: [],
  });
};
export const getBookingDetails = (dispatch, eventDate,setLoader) => {
  axios
    .get(
      `${REACT_APP_API_URL}/parking_slot_booking/${localStorage.getItem(
        "driver_id"
      )}/date/${eventDate}`
    )
    .then((res) => {
      dispatch({
        type: types.GET_BOOKING_DETAILS,
        payload: res.data.response.bookings,
      });
      if(setLoader)
      {
        setLoader(false)
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getChargingSiteBundles = (dispatch, ev_charging_site_id) => {
  const driver_id = localStorage.getItem("driver_id");
  axios
    .get(
      `${REACT_APP_API_URL}/ev_charging_site_bundles/ONET/ev_charging_site_id/${ev_charging_site_id}/driver/${driver_id}`
    )
    .then((res) => {
      dispatch({
        type: types.GET_CHARGING_SITES_BUNDLES,
        payload: res.data.response,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

// export const getParkingSlots = (
//   dispatch,
//   ev_charging_site_id,
//   ev_charging_site_bundle_id
// ) => {
//   axios
//     .get(
//       `${REACT_APP_API_URL}/parkingslots/ev_charging_site/${ev_charging_site_id}/ev_charging_site_bundle/${ev_charging_site_bundle_id}`,
//       {
//         headers: {
//           token: localStorage.getItem("driverToken"),
//         },
//       }
//     )
//     .then((res) => {
//       dispatch({
//         type: types.GET_PARKING_SLOTS,
//         payload: res.data.response.parkingSlots,
//       });
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// };

export const addNewBooking = (dispatch, payload, activeMonthDate) => {
  axios
    .post(REACT_APP_API_URL + "/driver_bundle_subscription_onetime", payload)
    .then(function ({ data }) {
      dispatch({
        type: types.BOOKING_CREATED_SUCCESSFULLY,
        payload: true,
      });
      const startOfMonth = moment(activeMonthDate)
        .startOf("month")
        .format(MOMENT_FORMAT);
      const endOfMonth = moment(activeMonthDate)
        .endOf("month")
        .format(MOMENT_FORMAT);
      const driver_id = localStorage.getItem("driver_id");
      fetchBookings(dispatch, startOfMonth, endOfMonth, driver_id);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getStationName = (dispatch, ev_charging_site_id) => {
  axios
    .get(`${REACT_APP_API_URL}/ev_charging_site/${ev_charging_site_id}`)
    .then(({ data }) => {
      dispatch({
        type: types.GET_STATION_NAME,
        payload: data.response.evChargingSite,
      });
      getPlanSelectionName(dispatch);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPlanSelectionName = (dispatch) => {
  axios
    .get(
      REACT_APP_API_URL +
      `/ev_charging_site/bundle_subscription_type_list/${localStorage.getItem(
        "ev_charging_site_id"
      )}`
    )
    .then(function ({ data }) {
      console.log("listAll",data.response)
      dispatch({
        type: types.GET_PLAN_SELECTION_NAME,
        payload: data.response.bundleDescriptionSubscriptionList,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPlanStaionBundle = (dispatch, plan_id, ev_charging_site_id) => {
  dispatch({ type: types.CLEAR_PARKING_SLOTS });
  axios
    .get(
    `${REACT_APP_API_URL}/ev_charging_site_bundles/${plan_id}/ev_charging_site_id/${ev_charging_site_id}/${plan_id==='FLEX'||plan_id==='ANYT'?`/driver/${localStorage.getItem("driver_id")}`:""}`
    )
    .then(({ data }) => {
      console.log("cleARR",data)
      dispatch({
        type: types.GET_PLAN_STATION_BUNDLE,
        payload: data.response.evChargingSiteBundles,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getParkingSlot = (
  dispatch,
  charging_site_bundle_id,
  ev_charging_site_id
) => {
  axios
    .get(
      `${REACT_APP_API_URL}/parkingslots/ev_charging_site/${ev_charging_site_id}/ev_charging_site_bundle/${charging_site_bundle_id}`
    )
    .then(({ data }) => {
      dispatch({
        type: types.GET_PARKING_SLOTS,
        payload: data.response.parkingSlots,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};
export const addDriverBundleSubscriptionWithNoParking = ( payload,setCongratulationScreen, setSubmitPlan) => {
  axios
    .post(`${REACT_APP_API_URL}/driver_bundle_subscription_with_no_parking_slot/`, payload)
    .then((res) => {
      console.log("response",res)
      setCongratulationScreen(true)
    })
    .catch((err) => {
      console.log(err);
      setSubmitPlan(false)
    });
};

export const addDriverBundleSubscription = (dispatch, payload, setSubmitPlan) => {
  axios
    .post(`${REACT_APP_API_URL}/driver_bundle_subscription/`, payload)
    .then((res) => {
      dispatch({ type: types.DRIVER_BUNDLE_SUBSCRIPTION_CREATED });
    })
    .catch((err) => {
      console.log(err);
      setSubmitPlan(false)
    });
};

export const getBundleDayReference = (dispatch) => {
  dispatch({ type: types.CLEAR_PARKING_SLOTS });
  axios
    .post(`${REACT_APP_API_URL}/retrieve_ref_table`, {
      table_name: "day_ref",
    })
    .then(({ data }) => {
      dispatch({
        type: types.GET_BUNDLE_DAY_REFERENCE,
        payload: data.response.result,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDayReferenceChargingSiteBundle = (
  dispatch,
  day_code,
  ev_charging_site_id,
  route
) => {
  console.log("getDayReferenceChargingSiteBundleDISPATCH",day_code,
  )

  axios
    .get(
      `${REACT_APP_API_URL}/ev_charging_site_bundles/ev_charging_site_id/${ev_charging_site_id}${day_code? `/DAYCODE/${day_code}`:`/${route}`}`
    )
    .then(({ data }) => {
      console.log("getDayReferenceChargingSiteBundle",data)
      dispatch({
        type: types.GET_DAY_REFERENCE_CHARGING_SITE_BUNDLE,
        payload: data.response.evChargingSiteBundles,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDayshareParkingSlot = (dispatch, payload) => {
  axios
    .post(`${REACT_APP_API_URL}/find_parking_slots`, payload)
    .then(({ data }) => {
      dispatch({
        type: types.GET_DAYSHARE_PARKING_SLOTS,
        payload: data.response.parkingSlots,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDayshareOneTimeParkingSlot = (dispatch, payload) => {
  axios
    .post(`${REACT_APP_API_URL}/find_one_time_parking_slots`, payload)
    .then(({ data }) => {
      dispatch({
        type: types.GET_DAYSHARE_PARKING_SLOTS,
        payload: data.response.availableParkingSlots,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDriverBundleSubscriptions = (dispatch) => {
  const driver_id = localStorage.getItem("driver_id");
  axios
    .get(
      `${REACT_APP_API_URL}/driver_bundle_subscription_by_driver_id/${driver_id}`
    )
    .then(({ data }) => {
      dispatch({
        type: types.GET_DRIVER_BUNDLE_SUBSCRIPTIONS,
        payload: data.response.driverBundleSubscriptions,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const cancelSlotBooking= async (dispatch, parkingSlotBookingID,eventDate,setLoader,startOfMonths,endOfMonths)=>{
  axios
  .put(REACT_APP_API_URL + "/cancel_parking_slot_booking/" + parkingSlotBookingID)
    .then(function ({ data }) {
    let dateNow = new Date()
      const activeMonthDate = moment(dateNow ,MOMENT_FORMAT)
      .subtract(1, "M")
      .endOf("month");
      const startOfMonth = moment(activeMonthDate)
      .startOf("month")
      .format(MOMENT_FORMAT);
    const endOfMonth = moment(activeMonthDate)
      .endOf("month")
      .format(MOMENT_FORMAT);
    const driver_id = localStorage.getItem("driver_id");
    if(eventDate)
    {
      getBookingDetails(dispatch,eventDate,setLoader)

    }
    fetchBookings(dispatch, startOfMonths||startOfMonth, endOfMonths||endOfMonth, driver_id);
  })
  .catch(function (error) {
    console.log(error);
  });
}

export const cancelDriverBundleSubscriptionCycles = (
  dispatch,
  driver_subscription_id
) => {
  axios
    .put(
      REACT_APP_API_URL +
      "/cancel_driver_bundle_subscription_cycles/" +
      driver_subscription_id,
      {}
    )
    .then(function ({ data }) {
      getDriverBundleSubscriptions(dispatch);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const apiEndpointFailed = (
  dispatch,
  isApiEndPointFailed,
  { errorStatusCode, message, error }
) => {
  let title = `Error ${errorStatusCode}: ${message}`;
  dispatch({
    type: types.API_ENDPOINT_FAILED,
    payload: { title, bodyMessage: error, isApiEndPointFailed },
  });
};


export const getChargeDetails = (dispatch, driverId) => {
  axios
    .get(REACT_APP_API_URL + `/usage_detail/${driverId}`)
    .then(({ data }) => {
      dispatch({
        type: types.GET_CHARGE_DETAIL,
        payload: data.response.detail,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getPaymentDetails = (dispatch, driverId) => {
  axios
    .post(REACT_APP_API_URL + `/payment_details/driver/${driverId}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({
        type: types.GET_PAYMENT_DETAIL,
        payload: data.response.paymentDetails,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDriverChargingSites = (dispatch) => {
  const driver_id = localStorage.getItem("driver_id");
  axios
    .get(`${REACT_APP_API_URL}/drivers/sites/${driver_id}`)
    .then(({ data }) => {
      console.log("drivers",data)
      dispatch({
        type: types.GET_DRIVER_CHARGING_SITES,
        payload: data.response.driverEvChargingSites,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllChargingSites = (dispatch) => {
  axios
    .get(`${REACT_APP_API_URL}/ev_charging_site`)
    .then(({ data }) => {
      dispatch({
        type: types.GET_ALL_CHARGING_SITES,
        payload: data.response.evChargingSites,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const addDriverChargingSite = (dispatch, payload, callBack) => {
  const driver_id = localStorage.getItem("driver_id");
  axios
    .post(REACT_APP_API_URL + "/drivers/site", { ...payload, driver_id })
    .then(function ({ data }) {
      getDriverChargingSites(dispatch);
      callBack();
    })
    .catch(function (response) {
      if ([401, 400].includes(response.status)) {
        dispatch({
          type: types.DRIVER_PROFILE_CREATION_FAILED,
          payload: response.data.message,
        });
      }
    });
};

export const updateEvChargingSiteId = (dispatch, ev_charging_site_id) => {
  dispatch({
    type: types.UPDATE_EV_CHARGING_SITE_ID,
    payload: ev_charging_site_id,
  });
};

export const displayToast = (dispatch, payload) => {
  dispatch({
    type: types.SHOW_TOAST,
    payload: payload,
  });
};

export const sendNotification = (dispatch, payload) => {
  axios
    .post(
      REACT_APP_API_URL + "/notification/SendToEvChargingSite",
      payload
      // , {
      //   headers: { token: localStorage.getItem("driverToken") },
      // }
    )
    .then(function ({ data }) {
      dispatch({
        type: types.SHOW_TOAST,
        payload: { display: true, text: "Notification Sent" },
      });
    })
    .catch(function (response) {
      console.log("ERROR => ", response);
    });
};

export const startChargingVehicle = (dispatch, payload, callback) => {
  axios
    .post(
      REACT_APP_API_URL + "/remote_start_transaction",
      payload
      // {
      //   headers: { token: localStorage.getItem("driverToken") },
      // }
    )
    .then(function ({ data }) {
      displayToast(dispatch, {
        text: "Vehicle Charging Started!",
        display: true,
      });
      callback();

    })
    .catch(function (response) {
      callback();

      console.log("ERROR => ", response);
    });
};

export const stopChargingVehicle = (dispatch, payload, callback) => {
  axios
    .post(
      REACT_APP_API_URL + "/remote_stop_transaction",
      payload
      // {
      //   headers: { token: localStorage.getItem("driverToken") },
      // }
    )
    .then(function ({ data }) {
      displayToast(dispatch, {
        text: "Vehicle Charging Stopped!",
        display: true,
      });
      callback();
    })
    .catch(function (response) {
      console.log("ERROR => ", response);
    });
};

export const appOnlineOfflineMode = (dispatch, payload) => {
  dispatch({
    type: types.APP_ONLINE_OFFLINE_MODE,
    payload: payload,
  });
};

export const clearDriverChargingSite = (dispatch) => {
  dispatch({
    type: types.CLEAR_DRIVER_CHARGING_SITE,
  });
};
